import { ɵisRemoteConfigSupportedFactory } from '@angular/fire';

export const isSupported = ɵisRemoteConfigSupportedFactory.async;
